'use client';

import { useLinkStatus } from 'next/link';

export default function NavigationProgress() {
  const { pending } = useLinkStatus();

  return (
    <span
      aria-hidden="true"
      className={`navigation-progress ${pending ? 'navigation-progress-active' : ''}`}
    >
      <span className="navigation-progress-bar" />
    </span>
  );
}
